module.exports = __webpack_public_path__ + "static/media/crosswalkArrow.6729735a.svg";